import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-bl-textSoft" data-testid="auth-loading">
        Vérification…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
